
import { Box, } from "@mui/system";

import AppDownloadSection from "../component/AppDownloadSection";



import Secondimage from "../component/Secondimage";
import FeatureSection from "../component/Features";
import SecondSection from "../component/SecondSection";
import BannerSlider from "../component/BannerSlider";




const HeroSection = () => {
  return (
    <Box 
    >

      <BannerSlider />
      <SecondSection />

      <FeatureSection />
      <Secondimage />
      <AppDownloadSection />
      {/* <AppDownloadButtons/> */}
    </Box>
  );
};

export default HeroSection;
